import axios from 'axios';
import { del, get, post, put } from './api_helper';
import * as url from './url_helper';

export const getTableViewOptions = async ({ payload }: any) => {
  const clientId = JSON.stringify(
    JSON.parse(window.localStorage.getItem('authUser') || '').id,
  );

  const query = `query{
    WorkspaceViews(filter: {clientId: "${clientId}", groupName: "${payload.groupName}"}, order: {groupName: "ASC"}) {
      name
      clientId
      groupName
      default
      items {
        name
        label
        order
        dataField
      }
    }
  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.WorkspaceViews;
};

export const createTableView = async ({ payload }: any) => {
  const clientId = JSON.stringify(
    JSON.parse(window.localStorage.getItem('authUser') || '').id,
  );

  const columns = payload.columns.map((column: any, index: number) => {
    return `{
      label: "${column.text}",
      order: "${index}",
      dataField: "${column.dataField}"
    }`;
  });

  const query = `mutation {
    createWorkspaceViews(data:{
      name: "${payload.name}",
      default: ${payload.default} ,
      groupName: "${payload.groupName}",
      clientId: "${clientId}",
      items: [${columns}]
    }){
      success,
      errorMessage
    }
  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.createWorkspaceViews;
};

export const updateTableView = async ({ payload }: any) => {
  const clientId = JSON.stringify(
    JSON.parse(window.localStorage.getItem('authUser') || '').id,
  );

  const columns = payload.columns.map((column: any, index: number) => {
    return `{
      label: "${column.label || column.text}",
      order: "${index}",
      dataField: "${column.dataField}"
    }`;
  });

  const query = `mutation {
    updateWorkspaceViews(data:{
      name: "${payload.name}",
      default: ${payload.default} ,
      groupName: "${payload.groupName}",
      clientId: "${clientId}",
      items: [${columns}]
    }){
      success,
      errorMessage
    }
  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.updateWorkspaceViews;
};

export const deleteTableView = async ({ payload }: any) => {
  const clientId = JSON.stringify(
    JSON.parse(window.localStorage.getItem('authUser') || '').id,
  );

  const query = `mutation {
    deleteWorkspaceViews(data: {groupName: "${payload.groupName}", clientId: "${clientId}", name: "${payload.name}"}){
      success
      errorMessage
    }
  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());

  return response.data.deleteWorkspaceViews;
};
